module.exports = __webpack_public_path__ + "files/SPIADI2021.8043695b0e23390bf176d804bbe51e94.zip";